<template>
  <div class="card card-with-shadow border-0 h-100 employee-preview-card">
    <div
      class="
        card-body
        position-relative
        d-flex
        flex-column
        justify-content-between
      "
    >
      <div
        v-if="showAction"
        class="dropdown options-dropdown position-absolute"
      >
        <button
          type="button"
          class="
            btn-option btn
            d-flex
            align-items-center
            justify-content-center
          "
          data-toggle="dropdown"
        >
          <app-icon name="more-horizontal" />
        </button>
        <div class="dropdown-menu dropdown-menu-right py-2 mt-1">
          <a
            class="dropdown-item px-4 py-2"
            href="#"
            v-for="(action, index) in actions"
            :key="index"
            @click.prevent="callAction(action)"
          >
            {{ action.title }}
          </a>
        </div>
      </div>
      <div class="d-flex flex-column align-items-center">
        <!-- <app-avatar
          :title="profile.company_name"
          avatar-class="avatars-w-80 mb-2 mx-auto d-inline-block"
          :img="getImageUrl(profile)"
        /> -->
        <app-icon v-if="profile.is_parent === 0" name="file"/>
        <app-icon v-else name="folder"/>

        <h5 class="mb-1 mt-3" style="font-size: 1.15rem">
          {{ profile.name == null ?  '---' : profile.name }}
        </h5>
        <p class="mb-2 text-muted font-size-90">{{ profile.description == null ? '---' : profile.description }}</p>
        <!-- <p class="mb-2 text-muted font-size-90">{{ profile.category.title }}</p> -->

        <!-- <p class="mb-2 text-muted font-size-90">{{ profile.company_email }}</p>
        <p class="mb-2 text-muted font-size-90">Since: {{ profile.created_at | formatDate }}</p> -->
        <!-- <div class="my-3">
          <span
            :class="
              'badge badge-sm badge-pill badge-' + statusClass(profile.is_verify)
            "
            >{{ profile.is_verify == 0 ? 'Unverified' : 'Verified' }}</span
          >
        </div> -->
        <!-- <p class="mb-0">Membership:</p>
        <p v-if="profile.package != null" class="text-muted font-size-90 mb-0">{{ profile.package.title }}</p>
        <div class="mb-3">
          <span v-if="profile.start_date == null" :class="'badge badge-sm badge-pill badge-dark'">Inactive</span>
          <span v-else :class="'badge badge-sm badge-pill badge-primary'">Active</span>
        </div>
        <p v-if="profile.company_phone" class="mb-2">{{ profile.company_phone }}</p> -->
      </div>
    </div>
  </div>
</template>

<script>
import AppFunction from "../../../../../../core/helpers/app/AppFunction";

export default {
  name: "ProfileCard",
  props: {
    profile: {
      type: Object,
      required: true,
    },
    actions: {
      type: Array,
      required: true,
    },
    showAction: {
      type: Boolean,
      default: true,
    },
    id: {
      required: true,
    },
  },
  methods: {
    callAction(action) {
      console.log(action);
      this.$emit("action-" + this.id, this.profile, action, true);
    },
    getImageUrl(profile) {
      if (profile.logo) {
        return AppFunction.getAppUrl(profile.logo);
      }
      return AppFunction.getAppUrl("images/avatar-demo.jpg");
    },
    // statusClass(is_verify) {
    //   let ClassName = "danger";
    //   if (is_verify === 1) ClassName = `success`;
    //   else if (is_verify === 0) ClassName = `warning`;
    //   return ClassName;
    // },
  },
};
</script>
